module.exports = __webpack_public_path__ + "img/detBannerOrange.3911ce74.jpg";